export default __webpack_public_path__ + "static/media/women.f2c846df.jpg";